/**
 * ProcessingStatusBadge - Display processing status for records
 *
 * Shows real-time processing status (classifying, summarising, evaluating FOS, etc.)
 * Uses SignalProcessingStatusBadge from v3 for consistency.
 */

import React from 'react';
import SignalProcessingStatusBadge from '../../../v3/shared/SignalProcessingStatusBadge';
import type { Record } from '../../../../types/record';

interface ProcessingStatusBadgeProps {
  record: Record;
  className?: string;
}

/**
 * ProcessingStatusBadge Component
 *
 * Displays the processing status of a record, showing real-time progress
 * when the record is being classified, analyzed, summarized, or evaluated.
 */
export const ProcessingStatusBadge: React.FC<ProcessingStatusBadgeProps> = ({
  record,
  className = ''
}) => {
  // Extract progress data from record (updated via WebSocket)
  const progressStage = record._progress?.stage;
  const progressPercent = record._progress?.percent;
  
  return (
    <SignalProcessingStatusBadge
      processingStatus={record.processing_status}
      status={record.status}
      progressStage={progressStage}
      progressPercent={progressPercent}
      className={className}
    />
  );
};
